<template>
  <div class="tort-map-box">
    <!-- 侵权地图 -->
    <Row class="filter-box">
      <Row class="count-box">线索数量：{{ clueData?clueData.length:0 }}</Row>
    </Row>
    <Row class="map-box">
      <div id="tort-map"></div>
    </Row>
  </div>
</template>
<script>
export default {
  components: {},
  props: ['missionId'],
  data () {
    return {
      clueData: [],
      center: {}
    }
  },
  watch: {},
  created() {},
  beforeMount() {},
  mounted() {
    this.initMap()
    this.getData()
  },
  updated() {},
  methods: {
    // 根据任务id获取线索
    getData() {
      const url = '/business/clue/coordinates/lawyer'
      const ajaxData = {
        missionId: this.missionId
      }
      this.$get(url, ajaxData).then(res => {
        if (res.code == 0) {
          this.clueData = res.data
          this.clueData.forEach((item, index) => {
            this.makerPoint(item)
          })
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    /** ******  地图 start  ********/
    // 初始化地图
    initMap() {
      const that = this
      that.map = new AMap.Map('tort-map', {
        zoom: 11, // 级别
        // center: [116.397428, 39.90923], // 中心点坐标
        viewMode: '3D' // 使用3D视图
      })
      AMap.plugin(['AMap.PlaceSearch', 'AMap.AdvancedInfoWindow'], function () { // 异步同时加载多个插件
        that.setHotHover()
      })
      that.map.on('complete', () => {
      })
    },
    // 传入经纬度描点
    makerPoint(obj) {
      const m = new AMap.Marker({
        position: [obj.xattr, obj.yattr],
        icon: new AMap.Icon({
          image: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png',
          // size: new AMap.Size(35, 45), // 图标大小
          imageSize: new AMap.Size(20, 26)
        }),
        title: obj.shopName
      })
      this.map.add(m)
    },
    setHotHover() {
      const that = this
      const placeSearch = new AMap.PlaceSearch() // 构造地点查询类
      const infoWindow = new AMap.AdvancedInfoWindow({})
      that.map.on('hotspotclick', function (result) {
        console.log(1111111, result)
        placeSearch.getDetails(result.id, function (status, result) {
          console.log(33333333333, status, result)
          if (status === 'complete' && result.info === 'OK') {
            placeSearch_CallBack(result)
          }
        })
      })

      // 回调函数
      function placeSearch_CallBack(data) { // infoWindow.open(map, result.lnglat);
        var poiArr = data.poiList.pois
        var location = poiArr[0].location
        infoWindow.setContent(createContent(poiArr[0]))
        infoWindow.open(that.map, location)
      }

      function createContent(poi) { // 信息窗体内容
        var s = []
        s.push('<div class="info-title">' + poi.name + '</div><div class="info-content">' + '地址：' + poi.address)
        s.push('电话：' + poi.tel)
        s.push('类型：' + poi.type)
        s.push('<div>')
        return s.join('<br>')
      }
    }
    /** ******  地图 end  **********/
  }
}
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
<style lang="scss">
@import "@/assets/globalStyle.scss";
.amap-adcontent-body {
  margin-top: 0;
}
.amap-adcombo-close {
  background-color: #e4e1dd;
}
.map-box{
    height: 600px;
    overflow:auto;
    #tort-map{
        .citylist_popup_main{
            .city_content_top{
                box-sizing: content-box;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/infringementMap/index.vue